import script from "./EmpresasRepository.vue?vue&type=script&lang=js"
export * from "./EmpresasRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__